import * as Segment from '@hotjar/webapp/domains/common/tracking/segment';
import { multipleRecordingTags } from './multiple-recording-tags';
import { validateEventData } from './validate-event-data';
import type { AccountGroupingData, SiteGroupingData } from './utils';
import { tagRecording } from './tools/hotjar';

/**
 * Track when a modal has been dismissed/closed.
 */
export const closedModal = (
  name: string,
  groupData: AccountGroupingData | SiteGroupingData | undefined,
  data: Segment.SegmentTrackData = {},
): void => {
  const valid = validateEventData('Track.closedModal', [name, groupData]);

  if (valid) {
    const eventData = {
      ...data,
      ...groupData,
      modal_name: name,
    };

    const recordingTagsData: Array<Segment.SegmentTrackData[keyof Segment.SegmentTrackData]> = [];

    if (typeof data.name !== 'undefined') {
      recordingTagsData.push(data.name);
    }

    if (typeof data.modal_version !== 'undefined') {
      recordingTagsData.push(data.modal_version);
    }

    if (recordingTagsData.length) {
      multipleRecordingTags(
        'Modal Closed',
        // We have to flatten the data as SegmentTrackData can have arrays
        // within it.
        recordingTagsData.reduce<Array<string | number | boolean>>(
          (acc, value) => acc.concat(value),
          [],
        ),
      );
    } else {
      tagRecording('Modal Closed');
    }

    Segment.track('Modal Closed', eventData);
  }
};
